"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveAddressOperation = void 0;
var common_core_1 = require("@moralisweb3/common-core");
var dataTypes_1 = require("../../dataTypes");
/** Resolve an ETH address and find the ENS name. */
exports.resolveAddressOperation = {
    method: 'GET',
    name: 'resolveAddress',
    id: 'resolveAddress',
    groupName: 'resolve',
    isNullable: true,
    urlPathPattern: '/resolve/{address}/reverse',
    urlPathParamNames: ['address'],
    getRequestUrlParams: getRequestUrlParams,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
    deserializeResponse: deserializeResponse,
};
// Methods
function getRequestUrlParams(request, core) {
    return {
        address: (0, common_core_1.maybe)(request.address, function (address) { return dataTypes_1.EvmAddress.create(address, core).checksum; }),
    };
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest(request, core) {
    return {
        address: (0, common_core_1.maybe)(request.address, function (address) { return dataTypes_1.EvmAddress.create(address, core).checksum; }),
    };
}
function deserializeRequest(jsonRequest, core) {
    return {
        address: (0, common_core_1.maybe)(jsonRequest.address, function (address) { return dataTypes_1.EvmAddress.create(address, core); }),
    };
}
//# sourceMappingURL=resolveAddressOperation.js.map